import { render } from "./FileDropzoneTypeComponent.vue?vue&type=template&id=648e4cc2&scoped=true"
import script from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"
export * from "./FileDropzoneTypeComponent.vue?vue&type=script&lang=js"

import "./FileDropzoneTypeComponent.vue?vue&type=style&index=0&id=648e4cc2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648e4cc2"]])

export default __exports__